import { render } from "./KidsExcursions.vue?vue&type=template&id=6365904d&scoped=true"
import script from "./KidsExcursions.vue?vue&type=script&lang=js"
export * from "./KidsExcursions.vue?vue&type=script&lang=js"

import "./KidsExcursions.vue?vue&type=style&index=0&id=6365904d&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6365904d"]])

export default __exports__